import React from 'react';
import groupDiscussion from "../../../assets/images/groupDiscussion.png";

const GdWait = () => {
  return (
    <div className="flex flex-1 flex-col justify-center items-center h-full">
      <img
        src={groupDiscussion}
        alt="Group Discussion"
        className="object-contain mb-4"
        style={{ height: '20%', width: '35%' }}
      />
      <span
        className="text-white text-center text-base"
        style={{
          padding: '1.5%',
          fontFamily: "'Lato', sans-serif",
          width: '60%',
          marginBottom: '1%',
        }}
      >
        Trainer would like you to volunteer for group presentations<br />
        Group Leaders to volunteer NOW
      </span>
    </div>
  );
};

export default GdWait;